import { Observable, Subscription } from 'rxjs';
import { watch } from 'vue';
export function useWatchObservable(sources, options = { immediate: false }) {
    return new Observable((observe) => {
        const _unwatch = watch(sources, (newVal, oldVal) => {
            observe.next({ newVal, oldVal: oldVal });
        }, options);
        return new Subscription(() => {
            if (_unwatch)
                _unwatch();
        });
    });
}
//# sourceMappingURL=useWatchObservable.js.map